import React, { useState, useEffect } from 'react';

import { Tooltip } from 'antd';
import { SortAscendingOutlined, SortDescendingOutlined } from '@ant-design/icons';

import { ISortbarCommand } from '../../../../../../../../common/models/Sortbar';

const CommandOrderSap: React.FunctionComponent<ISortbarCommand> = ({ type, sorting, action }) => {
    const [commandActive, setCommandActive] = useState<boolean>(false);

    const _handleCommandAction = () => {
        if (!action) {
            return;
        }

        action();
    }

    useEffect(() => {
        sorting.type == type ? setCommandActive(true) : setCommandActive(false);
    }, [sorting]);

    return (
        <div className="command" onClick={_handleCommandAction}>
            {commandActive && sorting.sorting === 'asc'
                ?
                <Tooltip title="Ascending">
                    <span className="command-label">
                        Sap
                    </span>

                    {commandActive &&
                        <SortAscendingOutlined />
                    }
                </Tooltip>
                :
                <Tooltip title="Descending">
                    <span className="command-label">
                        Sap
                    </span>

                    {commandActive &&
                        <SortDescendingOutlined />
                    }
                </Tooltip>
            }
        </div>
    );
}

export default CommandOrderSap;